const FAQ = () => {
  return <div className="container mx-auto bg-white p-2 relative">FAQ</div>;
};

export default FAQ;
